import { pickElement } from './utils'
import { ALLIANZ_VARS } from '../config'

export function reloadDRPForSPA() {
  window.addEventListener('locationchange', function () {
    const iconoTel = ALLIANZ_VARS.paths.iconTel
      
    pickElement('.headerButtonsSt').innerHTML = `
                       <div class="c-header-metabar__target c-header__navigation" id="ringpoolDesktop">
                           <div class="c-header-metabar__content" id="divFlex"></div>
                           <a
                               href="tel:912866762"
                               class="drp-phone-new wal-drp-phone"
                               id="ringPoolDesktopText"    
                           >
                               91 286 67 62
                           </a
                           ><img
                               src=${iconoTel}
                               id="ringpoolIconDesktop"
                           />
                       </div>
                   `
  })
  ;(() => {
    const oldPushState = history.pushState
    history.pushState = function pushState() {
      const ret = oldPushState.apply(this, arguments)
      window.dispatchEvent(new Event('pushstate'))
      window.dispatchEvent(new Event('locationchange'))
      return ret
    }

    const oldReplaceState = history.replaceState
    history.replaceState = function replaceState() {
      const ret = oldReplaceState.apply(this, arguments)
      window.dispatchEvent(new Event('replacestate'))
      window.dispatchEvent(new Event('locationchange'))
      return ret
    }

    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('locationchange'))
    })
  })()
}

export function getChangeURL(callback) {
  window.addEventListener('popstate', callback)
  window.addEventListener('hashchange', callback)
}
